<template>
  <div id="UserManagement">
    <v-container fluid>
      <v-card class="elevation-0" height="70">
        <v-card-title>
          <v-row>
            <v-col cols="auto">
              <span class="text-h6">Users ({{ users.length }})</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="pa-0" cols="2">
              <v-text-field clearable dense label="Search" outlined v-model="search"></v-text-field>
            </v-col>
            <v-col class="pa-0 ml-5 mr-1" cols="auto">
              <v-btn @click="startCreateUser" class="primary elevation-0" >
                CREATE USER
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
      <v-row>
        <v-col class="px-5" cols="12">
          <v-data-table fixed-header height="calc(100vh - 320px)" :headers="headers" :items="users" :footer-props="{itemsPerPageOptions:[25,50,100]}"
                        :items-per-page="25" :search="search" class="elevation-0">
            <template v-slot:no-data>No Users Available</template>
            <template v-slot:no-results>No Users Available</template>
            <template v-slot:item.name="{ item }">
              {{ item.name ? item.name : '-' }}
            </template>
            <template v-slot:item.type="{ item }">
              {{ item.Type ? item.Type.name : '-' }}
            </template>
            <template v-slot:item.mobile="{ item }">
              {{ item.mobile ? item.mobile : '-' }}
            </template>
            <template v-slot:item.email="{ item }">
              {{ item.email ? item.email : '-' }}
            </template>
            <template v-slot:item.lastLoggedIn="{  }">
              {{ moment().format('DD MMM, YYYY hh:mm A') }}
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ dateTimeFilter(item.created_at) }}
            </template>
            <template v-slot:item.status="{ item }">
              {{ item.status ? item.status : '-' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu nudge-bottom="25">
                <template v-slot:activator="{ on:menu }">
                  <v-btn icon v-on="{...menu}">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item :key="i" @click="onClickAction(action,item)" dense
                               v-for="(action, i) in actionArr">
                    <v-list-item-title> {{
                        action.id === '2'
                            ? (item.status === 'ACTIVE' ? 'Inactive' : 'Active')
                            : action.title
                      }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <CreateUpdateUser :user="selectedUser" :userDialog="userDialog" @cancel="userDialog=false" @saveUser="saveUser"
                      v-if="userDialog" @error="showError"></CreateUpdateUser>
    <ConfirmationDialog :confirmationMessage="confirmMsg" @close="confirmationDialog=false;confirmMsg = 'Confirm! '"
                        @confirm="confirmAction" v-if="confirmationDialog"></ConfirmationDialog>
    <Snackbar :toaster="toaster"></Snackbar>
  </div>
</template>

<script>
import moment from 'moment'
import ConfirmationDialog from '../Common/ConfirmationDialog'
import CreateUpdateUser from './CreateUpdateUser'
import Snackbar from '../Common/Snackbar'
import { SUBSCRIBE_ALL_USERS } from '@/graphql/subscriptions/Users'
import { SOFT_DELETE_USER } from '@/graphql/mutations/Users'

export default {
  name: 'UserManagement',
  components: { Snackbar, CreateUpdateUser, ConfirmationDialog },
  data () {
    return {
      moment: moment,
      search: '',
      confirmationDialog: false,
      userDialog: false,
      toaster: { enable: false, color: 'green', message: '' },
      confirmMsg: 'Confirm! ',
      selectedAction: {},
      selectedUser: {},
      headers: [
        { text: 'Name', value: 'name' }, { text: 'Type', value: 'type' },
        { text: 'Mobile', value: 'mobile' }, { text: 'Email', value: 'email' },
        { text: 'Last Logged In', value: 'lastLoggedIn' },
        { text: 'Created On', value: 'created_at' },
        { text: 'Status', value: 'status' }, { text: 'Actions', value: 'actions' },
      ],
      users: [],
      actionArr: [{ id: '1', title: 'Edit' }, { id: '2', title: 'Delete' }],
      loggedInUser: JSON.parse(localStorage.user),
    }
  },
  apollo: {
    $subscribe: {
      Users: {
        query: SUBSCRIBE_ALL_USERS, fetchPolicy: 'network-only',
        skip () { return !this.loggedInUser },
        variables () { return { orgId: this.loggedInUser.organizationId } },
        result ({ data, loading }) { if (!loading) { this.users = data.Users } },
      },
    },
  },
  methods: {
    onClickAction (selectedAction, selectedUser) {
      this.selectedUser = selectedUser
      this.selectedAction = this.actionArr.filter(action => selectedAction.id === action.id)[0]
      if (this.selectedAction.id === '1')
        this.confirmAction()
      else if (this.selectedAction.id === '2')
        this.confirmMsg = this.confirmMsg.concat('this will update user status, are you sure?')
      this.confirmationDialog = this.selectedAction.id !== '1'
    },
    confirmAction () {
      this.confirmationDialog = false
      this.confirmMsg = 'Confirm! '
      if (this.selectedAction.id === '1')
        this.updateUser()
      else if (this.selectedAction.id === '2')
        this.deleteUser()
    },
    startCreateUser () {
      this.selectedUser = null
      this.userDialog = true
    },
    updateUser () {
      this.userDialog = true
    },
    async deleteUser () {
      let response = await this.$apollo.mutate({
        mutation: SOFT_DELETE_USER,
        variables: {
          id: this.selectedUser.id,
          status: this.selectedUser.status === 'INACTIVE' ? 'ACTIVE' : 'INACTIVE',
        },
      })
      if (response.data)
        this.toaster = { enable: true, color: 'green', message: 'User successfully updated' }
    },
    saveUser () {
      this.toaster = {
        enable: true, color: 'green',
        message: `User ${this.selectedUser ? 'updated' : 'created'} successfully`,
      }
      this.userDialog = false
    },
    showError (message) {
      this.toaster = { enable: true, color: 'red', message: message }
    },
  },
}
</script>

<style scoped>
.v-list {
  padding: 0;
}
</style>
